import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Modulos } from 'src/app/core/modulos';
import { AcessoModuloResolver } from 'src/app/guards/acesso-modulo.resolve';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { CadastrarMatriculaSecretariaComponent } from './cadastrar-matricula-secretaria/cadastrar-matricula-secretaria.component';
import { MatriculaSecretariaComponent } from './matricula-secretaria.component';


const routes: Routes = [
  { path: 'matriculasecretaria/cadastrar', component: CadastrarMatriculaSecretariaComponent,canActivate: [AuthGuard], resolve: {perfilAcesso:AcessoModuloResolver}, data:{modulo:Modulos.MATRICULA_SECRETARIA} },
  { path: 'matriculasecretaria', component: MatriculaSecretariaComponent,canActivate: [AuthGuard], resolve: {perfilAcesso:AcessoModuloResolver}, data:{modulo:Modulos.MATRICULA_SECRETARIA} },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MatriculaSecretariaRoutingModule { }
